import React from "react";
import LeftImg from './images/services/hr-img.jpg'
import Icon01 from './images/services/hr-1.png'
import Icon02 from './images/services/hr-2.png'
import Icon03 from './images/services/hr-3.png'
import Icon04 from './images/services/hr-4.png'
import Icon05 from './images/services/hr-5.png'
import Icon06 from './images/services/hr-6.png'
function HRManagementInfo() {
  return (
    <section className="image-description-section section">
        <p className="section-heading">HTI’s Cloud HR Management Tool lets businesses better manage, track and assess their people. 
</p>
    <div className="image-description-left image-section-left">
        <img src={LeftImg} alt="Description Image" className="image_description"
        style={{filter:'invert(0)'}}
        />
    </div>
    <div className="image-description-right description">
        <h2 className="heading-underline">Key Features</h2>
        <p className="description-para">
            <img src={Icon01} width={30} height={30} className="img-fluid" alt="icons"/>
            Employee management & tracking 
 </p>
        <p className="description-para">
            <img src={Icon02} width={30} height={30} className="img-fluid" alt="icons"/>
            Administration  module
 </p>
        <p className="description-para">
            <img src={Icon03} width={30} height={30} className="img-fluid" alt="icons"/>
            Inventory management system
 </p>
        <p className="description-para">
            <img src={Icon04} width={30} height={30} className="img-fluid" alt="icons"/>
            Employee Leave management 
</p>
        <p className="description-para">
            <img src={Icon05} width={30} height={30} className="img-fluid" alt="icons"/>
            Employee Salary management 
 </p>
              <p className="description-para">
            <img src={Icon05} width={30} height={30} className="img-fluid" alt="icons"/>
            Fast filters and search </p>
            <p className="description-para">
            <img src={Icon06} width={30} height={30} className="img-fluid" alt="icons"/>
            Reports and dashboards for analytics 
 </p>
    </div>
</section>  
  )
}
export default HRManagementInfo;